/**
 * WEBSOCKET / SIGNALR FAN SERVICE: CARRERA CONTINUA
 * Conexión en tiempo real del aficionado móvil para telemetría, cuenta regresiva y sincronización.
 */

import SignalRService from './SignalRService';

let messageHandler = null;
let reconnectedHandler = null;

/**
 * Conecta el dispositivo móvil del aficionado al Hub de SignalR con el rol 'carreracontinua:fan'.
 * @param {Function} onIncomingMessage - Callback para recibir mensajes y eventos emitidos por el Hub.
 * @param {Function} onStatusChange - Callback para notificar cambios de estado ('connecting', 'connected', 'error').
 * @param {string} roomId - Identificador único de la sala / partido.
 * @param {string} userZone - Identificador o nombre de la zona asignada al aficionado.
 */
export const ConnectWebSocketForCarreraContinuaFan = (
    onIncomingMessage = () => {},
    onStatusChange = () => {},
    roomId = '',
    userZone = ''
) => {
    onStatusChange('connecting');

    // Desuscribir handlers previos si existieran
    if (messageHandler) {
        SignalRService.off('message', messageHandler);
    }
    if (reconnectedHandler) {
        SignalRService.off('reconnected', reconnectedHandler);
    }

    messageHandler = (envelope) => {
        if (!envelope) return;

        // Si el mensaje incluye RoomId, verificar que pertenezca a la sala activa (si fue provista)
        const msgRoomId = envelope.roomId || envelope.RoomId || envelope.payload?.roomId || envelope.data?.roomId;
        if (roomId && msgRoomId && String(msgRoomId).toLowerCase() !== String(roomId).toLowerCase()) {
            return;
        }

        if (typeof onIncomingMessage === 'function') {
            onIncomingMessage(envelope);
        }
    };

    reconnectedHandler = () => {
        onStatusChange('connected');
    };

    SignalRService.on('message', messageHandler);
    SignalRService.on('reconnected', reconnectedHandler);

    SignalRService.connect({
        tipo: 'carreracontinua:fan',
        roomId: roomId || '',
        userZone: userZone || '',
        zona: userZone || ''
    })
        .then(() => {
            onStatusChange('connected');
        })
        .catch((err) => {
            console.error("[CarreraContinuaFanWS] Error al conectar a SignalR:", err);
            onStatusChange('error');
        });
};

/**
 * Desconecta limpiamente la sesión SignalR del aficionado móvil.
 */
export const DisconnectWebSocketForCarreraContinuaFan = () => {
    try {
        if (messageHandler) {
            SignalRService.off('message', messageHandler);
            messageHandler = null;
        }
        if (reconnectedHandler) {
            SignalRService.off('reconnected', reconnectedHandler);
            reconnectedHandler = null;
        }
        SignalRService.disconnect();
    } catch (err) {
        console.error("[CarreraContinuaFanWS] Error al desconectar de SignalR:", err);
    }
};

export default {
    ConnectWebSocketForCarreraContinuaFan,
    DisconnectWebSocketForCarreraContinuaFan
};
